import { useState } from 'react'
import {
  Alert,
  AlertDescription,
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@axilon-apps/libs-ui-shadcn'

import CopyToClipboard from '../CopyToClipboard/CopyToClipboard'

type AlertVariant = 'default' | 'info' | 'success' | 'warning' | 'destructive'

interface Props {
  onConfirm: () => void
  openModal: boolean
  title: string
  description: string
  secret: string
  /**
   * Backwards-compatible with the prior `DefaultColorPalette` typing. Accepts
   * either a Joy color name (mapped below) or one of the new shadcn Alert
   * variants directly.
   */
  color: string
}

const joyColorToVariant: Record<string, AlertVariant> = {
  primary: 'info',
  neutral: 'default',
  success: 'success',
  warning: 'warning',
  danger: 'destructive'
}

const SecretModal = ({ openModal, title, description, secret, color, onConfirm }: Props) => {
  const [closeable, setClosable] = useState(false)

  const closeEnable = () => setClosable(true)
  const variant: AlertVariant = joyColorToVariant[color] ?? (color as AlertVariant) ?? 'info'

  return (
    <Dialog open={openModal}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <p className="text-sm">{description}</p>
        <Alert variant={variant} className="flex items-center justify-between gap-2">
          <AlertDescription className="font-mono">{secret}</AlertDescription>
          <CopyToClipboard textToCopy={secret} onCopySuccess={closeEnable} />
        </Alert>
        <div className="flex flex-col gap-4">
          <Button disabled={!closeable} onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default SecretModal
